export const RATECODE_CAMPAIGN_LIST_ACTION = "RATECODE_CAMPAIGN_LIST_ACTION";
export const RATECODE_CAMPAIGN_LIST_SUCCESS = "RATECODE_CAMPAIGN_LIST_SUCCESS";

export const RATECODE_CAMPAIGN_CREATE_ACTION = "RATECODE_CAMPAIGN_CREATE_ACTION";
export const RATECODE_CAMPAIGN_CREATE_SUCCESS = "RATECODE_CAMPAIGN_CREATE_SUCCESS";

export const RATECODE_LIST_ALL_ACTION = "RATECODE_LIST_ALL_ACTION";
export const RATECODE_LIST_ALL_SUCCESS = "RATECODE_LIST_ALL_SUCCESS";

export const RATECODE_LIST_WITH_PAGING_ACTION = "RATECODE_LIST_WITH_PAGING_ACTION";
export const RATECODE_LIST_WITH_PAGING_SUCCESS = "RATECODE_LIST_WITH_PAGING_SUCCESS";

export const RATECODE_LIST_ACTION = "RATECODE_LIST_ACTION";
export const RATECODE_LIST_SUCCESS = "RATECODE_LIST_SUCCESS";

export const RATECODE_DETAIL_ACTION = "RATECODE_DETAIL_ACTION";
export const RATECODE_DETAIL_SUCCESS = "RATECODE_DETAIL_SUCCESS";
export const RATECODE_DETAIL_CACHE_ACTION = "RATECODE_DETAIL_CACHE_ACTION";
export const RATECODE_DETAIL_CACHE_SUCCESS = "RATECODE_DETAIL_CACHE_SUCCESS";

export const RATECODE_SCHEDULE_ACTION = "RATECODE_SCHEDULE_ACTION";
export const RATECODE_SCHEDULE_SUCCESS = "RATECODE_SCHEDULE_SUCCESS";

export const RATECODE_SCHEDULE_CREATE_ACTION = "RATECODE_SCHEDULE_UPDATE_ACTION";
export const RATECODE_SCHEDULE_CREATE_SUCCESS = "RATECODE_SCHEDULE_UPDATE_SUCCESS";

export const RATECODE_DETAIL_CREATE_ACTION = "RATECODE_DETAIL_CREATE_ACTION";
export const RATECODE_DETAIL_CREATE_SUCCESS = "RATECODE_DETAIL_CREATE_SUCCESS";

export const RATECODE_UPDATE_ACTION = "RATECODE_UPDATE_ACTION";
export const RATECODE_UPDATE_SUCCESS = "RATECODE_UPDATE_SUCCESS";

export const RATECODE_LOCK_ACTION = "RATECODE_LOCK_ACTION";
export const RATECODE_LOCK_SUCCESS = "RATECODE_LOCK_SUCCESS";

export const RATECODE_FAIL = "RATECODE_FAIL"

export const RATECODE_USAGE_PLAN_DETAIL_ACTION = "RATECODE_USAGE_PLAN_DETAIL_ACTION";
export const RATECODE_USAGE_PLAN_DETAIL_SUCCESS = "RATECODE_USAGE_PLAN_DETAIL_SUCCESS";

export const STOCK_PRODUCTS_ACTION = "STOCK_PRODUCTS_ACTION";
export const STOCK_PRODUCTS_SUCCESS = "STOCK_PRODUCTS_SUCCESS";
